import type { BillKind, GstMode } from "@luckymenu/core";

/**
 * What each GST mode issues. See the GST table in ordering-billing-gst.md.
 *
 * | Mode          | Document        | Tax on bill   |
 * | none          | Bill            | None          |
 * | composition   | Bill of supply  | None          |
 * | regular       | Tax invoice     | CGST + SGST   |
 */
export function billKindFor(gstMode: GstMode): BillKind {
	switch (gstMode) {
		case "regular":
			return "tax_invoice";
		case "composition":
			return "bill_of_supply";
		case "none":
			return "plain";
	}
}

/** SAC for restaurant service, printed once on a tax invoice. */
export const RESTAURANT_SAC = "996331";

/**
 * The declaration a composition taxable person must print on a bill of supply.
 * Legal wording: printed exactly as written, in English, not translated.
 */
export const COMPOSITION_DECLARATION =
	"Composition taxable person, not eligible to collect tax on supplies";
